import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

import React from "react";
import styled from "styled-components/macro";
import { IntlProvider } from "react-intl";

import Header from "Header";
import LoadingContainer from "../LoadingContainer";
import ModalProvider from "ModalProvider";
import Routes from "components/Routes";
import { Provider as ThemeProvider } from "Theme";
import { Provider as ToastsProvider } from "lib/Toasts";

const StyledContainer = styled.section`
  display: flex;
  flex-flow: column;
  height: 100%;
`;

const StyledContent = styled.main`
  flex: 1;
  @media (min-height: 500px) {
    overflow: hidden;
  }
`;

export const Layout: React.FC = () => (
  <IntlProvider locale={navigator.language ?? "en-US"}>
    <ThemeProvider>
      <ModalProvider>
        <ToastsProvider>
          <StyledContainer>
            <Header />
            <StyledContent>
              <React.Suspense fallback={<LoadingContainer loading />}>
                <Routes />
              </React.Suspense>
            </StyledContent>
          </StyledContainer>
        </ToastsProvider>
      </ModalProvider>
    </ThemeProvider>
  </IntlProvider>
);
